import { apiNoVersionBase } from 'config/env'

import { LogFetchError } from 'app/shared_components/helpers'
import { apiBaseUrl } from 'app/shared_components/shared_base_url'

const v2ApiBaseUrl = `${apiNoVersionBase}/`

export const getProofOfIncome = () => {
  const url = `${apiBaseUrl}sm/reputation/proofofincome`
  return fetch(url, {
    credentials: 'include',
  })
    .catch((error) => LogFetchError(error))
    .then((res) =>
      res.ok
        ? res.json()
        : Promise.reject({
            statusCode: res.status,
            responseText: res.text(),
            statusText: res.statusText,
          }),
    )
    .then(
      (Record) => ({ ok: true, Record }),
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )
}

export const getExtraIncome = () => {
  const url = `${apiBaseUrl}sm/reputation/proofofincome/other`
  return fetch(url, {
    credentials: 'include',
  })
    .catch((error) => LogFetchError(error))
    .then((res) =>
      res.ok
        ? res.json()
        : Promise.reject({
            statusCode: res.status,
            responseText: res.text(),
            statusText: res.statusText,
          }),
    )
    .then(
      (extraIncome) => ({ ok: true, extraIncome }),
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )
}

export const putExtraIncome = (referenceId, extraIncome) => {
  const url = `${apiBaseUrl}sm/reputation/proofofincome/${referenceId}/other`
  const settings = {
    credentials: 'include',
    method: 'PUT',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(extraIncome),
  }

  const response = fetch(url, settings)
    .catch((error) => LogFetchError(error))
    .then((res) =>
      res.ok
        ? res.json()
        : Promise.reject({
            statusCode: res.status,
            statusText: res.statusText,
            responseText: res.text(),
          }),
    )
    .then(
      (result) => ({ ok: true, result }),
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )

  return response
}

export const postExtraIncome = (extraIncome) => {
  const url = `${apiBaseUrl}sm/reputation/proofofincome/other`
  const settings = {
    credentials: 'include',
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(extraIncome),
  }

  const response = fetch(url, settings)
    .catch((error) => LogFetchError(error))
    .then((res) =>
      res.ok
        ? res.json()
        : Promise.reject({
            statusCode: res.status,
            statusText: res.statusText,
            responseText: res.text(),
          }),
    )
    .then(
      (result) => ({ ok: true, result }),
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )

  return response
}

export const uploadDocument = (formData, agencyGUID = '') => {
  let url = `${apiBaseUrl}sm/reputation/proofofincome`
  if (agencyGUID !== '') {
    url = `${apiBaseUrl}sm/reputation/proofofincome?agency_id=${agencyGUID}`
  }
  const options = {
    method: 'POST',
    body: formData,
    credentials: 'include',
  }

  return fetch(url, options)
    .catch((error) => LogFetchError(error))
    .then((res) =>
      res.ok
        ? res.json()
        : Promise.reject({
            statusCode: res.status,
            statusText: res.statusText,
            responseText: res.text(),
          }),
    )
    .then(
      (result) => ({ ok: true, result }),
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )
}

export const deleteDocument = (id) => {
  const url = `${apiBaseUrl}sm/reputation/proofofincome/${id}`
  const options = {
    method: 'DELETE',
    credentials: 'include',
  }

  return fetch(url, options)
    .catch((error) => LogFetchError(error))
    .then((res) =>
      res.ok
        ? Promise.resolve()
        : Promise.reject({
            statusCode: res.status,
            responseText: res.text(),
            statusText: res.statusText,
          }),
    )
    .then(
      (_) => ({ ok: true, _ }),
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )
}

export const postManualBankStatementRedactions = (documentGuid, areas) => {
  const url = `${apiBaseUrl}sm/reputation/proofofincome/${documentGuid}/manual-redactions`
  const settings = {
    credentials: 'include',
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ areas }),
  }

  return fetch(url, settings)
    .catch((error) => LogFetchError(error))
    .then((res) => {
      if (res.ok) {
        return Promise.resolve()
      }
      const err = new Error(res.statusText || 'Request failed')
      err.statusCode = res.status
      err.responseText = res.text()
      err.statusText = res.statusText
      return Promise.reject(err)
    })
    .then(
      () => ({ ok: true }),
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )
}

export const postStagedBankStatementManualRedactions = (
  propertyID,
  blobGuid,
  areas,
) => {
  const url = `${v2ApiBaseUrl}v2/sm/property/${propertyID}/apply/staged-bank-statement/${blobGuid}/manual-redactions`
  const settings = {
    credentials: 'include',
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ areas }),
  }

  return fetch(url, settings)
    .catch((error) => LogFetchError(error))
    .then((res) =>
      res.ok
        ? res.json().then((result) => ({ ok: true, result }))
        : Promise.reject({
            statusCode: res.status,
            responseText: res.text(),
            statusText: res.statusText,
          }),
    )
    .then(
      (result) => result,
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )
}

export const postGenerateDownloadUrl = (s3Url) => {
  const url = `${v2ApiBaseUrl}v2/sm/applications/download-url`
  const settings = {
    credentials: 'include',
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ s3Url }),
  }

  return fetch(url, settings)
    .catch((error) => LogFetchError(error))
    .then((res) =>
      res.ok
        ? res.json().then((result) => ({ ok: true, result }))
        : Promise.reject({
            statusCode: res.status,
            responseText: res.text(),
            statusText: res.statusText,
          }),
    )
    .then(
      (result) => result,
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )
}

export const postGenerateTranslationPreview = (s3Url) => {
  const url = `${v2ApiBaseUrl}v2/sm/applications/translation-preview`
  const settings = {
    credentials: 'include',
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ s3Url }),
  }

  return fetch(url, settings)
    .catch((error) => LogFetchError(error))
    .then((res) => {
      if (res.ok) {
        return res.json().then((result) => ({ ok: true, result }))
      }
      const err = new Error(res.statusText || 'Request failed')
      err.statusCode = res.status
      err.statusText = res.statusText
      return Promise.reject(err)
    })
    .then(
      (result) => result,
      (error) => ({
        ok: false,
        statusCode: error.statusCode,
        responseText: error.responseText,
        statusText: error.statusText,
      }),
    )
}
